<app-help-page-banner [items]="" [returnAddress]="'/HelpPage'"></app-help-page-banner>
<div class="container">
    <!-- StartPage -->
    <h2>{{'Abbild der Signalleuchte des Schaltschrankes' | translate}}</h2>
    <h3 class="subheading" id="OperIcons">{{'Bedeutung der Signalleuchten' | translate}}</h3>
    <div style="background-color: white; padding: 20px; display: flex; gap: 2%">
        <div >
            <h4>{{'Allgemein' | translate}}</h4>
            <p><span
                    style="display:inline-block; width:15px; height:15px; background-color:green; border-radius:50%; margin-right:8px;"></span>{{'Automatikbetrieb' | translate}}
            </p>
            
            <p><span
                    style="display:inline-block; width:15px; height:15px; background-color:red; border-radius:50%; margin-right:8px;"></span>{{'Störung' | translate}}
            </p>
            <p><span
                    style="display:inline-block; width:15px; height:15px; background-color:grey; border-radius:50%; margin-right:8px;"></span>{{'Keine Daten seit 12h / Gerät ist nicht im Lager' | translate}}
            </p>
        </div>
        <div class="vr" role="separator" aria-orientation="vertical"></div>
        <div>
            <h4>{{'Heber / MLS / RBG / PRBG' | translate}}</h4>
            <p><span
                    style="display:inline-block; width:15px; height:15px; background-color:blue; border-radius:50%; margin-right:8px;"></span>{{'Handbetrieb/Testfahrt' | translate}}
            </p>
            <p><span
                    style="display:inline-block; width:15px; height:15px; background-color:orange; border-radius:50%; margin-right:8px;"></span>{{'Warnung' | translate}}
            </p>
        </div>
        <div class="vr" role="separator" aria-orientation="vertical"></div>
        <div>
            <h4>{{'OLS / OLPS' | translate}}</h4>
            <p><span
                    style="display:inline-block; width:15px; height:15px; background-color:blue; border-radius:50%; margin-right:8px;"></span>{{'Meldung steht an z.B. Warte auf Auslagerbahn' | translate}}
            </p>
            <p><span
                    style="display:inline-block; width:15px; height:15px; background-color:orange; border-radius:50%; margin-right:8px;"></span>{{'Handbetrieb' | translate}}
            </p>
        </div>
    </div>

    <h3 class="subheading" id="OperIcons">{{'Der digitale Zwilling' | translate}}</h3>
    <img id="digitalTwin"
        src="{{environment.storageUrl}}/models3d/general/helpPage/introduction/Notification/helppage_digitaltwin.png"
        class="embed-responsive mx-auto d-block" style="width: 80%;" alt="Ordered listing of signals">

    <h3 class="subheading" id="OperIcons">{{'Kacheln / Maschinen' | translate}}</h3>
    <img id="tiles"
        src="{{environment.storageUrl}}/models3d/general\helpPage/introduction/Notification/devicesOverview.png"
        class="embed-responsive mx-auto d-block" style="width: 80%;" alt="Device tiles">
    <h3 class="subheading" id="OperIcons">{{'Galileo Notification App' | translate}}</h3>
    <ol>
        <li>
            <p>{{'Zunächst müssen Sie sicherstellen, dass die Galileo Notification App auf Ihrem Endgerät
                installiert ist.' | translate}}</p>
            <img id="installations"
                src="{{environment.storageUrl}}/models3d/general\helpPage\introduction/Notification/search_app_appstore.png"
                class="embed-responsive mx-auto d-block" style="width: 45%;" alt="App search inside appstore">
        </li>
        <li>
            <p>
                {{'Sobald die Installation abgeschlossen ist, können Sie die App öffnen.' | translate}}
            </p>
            <img id="AppIcon"
                src="{{environment.storageUrl}}/models3d/general\helpPage\introduction/Notification/app_homescreen_phone.png"
                class="embed-responsive mx-auto d-block" style="width: 15%;" alt="App on startscreen">
        </li>
        <li>
            <p>
                {{"Nachdem öffnen der App, tippen Sie auf den 'Anmelden' Button. Es öffnet sich nun die Anmeldemaske." |
                translate }}
            </p>
            <img id="openApp"
                src="{{environment.storageUrl}}/models3d/general\helpPage\introduction/Notification/login_window.png"
                class="embed-responsive mx-auto d-block" style="width: 80%;"
                alt="App is open and the 'Login' Button is visible">
        </li>
        <li>
            <p>
                {{'Nach der erfolgreichen Anmeldung können Sie nun damit beginnen mithilfe der App einen Barcode zu
                scannen. Der erste Barcode (1) dient zu Anzeige aller Geräte während einer der unteren Barcodes (3-11)
                zur Anzeige eines Einzelgerätes dient.' |
                translate}}
            </p>
            <div style="display: flex;">
                <img id="BarcodeDevice"
                    src="{{environment.storageUrl}}/models3d/general\helpPage\introduction/Notification\barcode_alldevices_single_device.png"
                    class="embed-responsive  d-block" style="width: 60%;"
                    alt="Image of where 'Einzelgeräte' and 'Alle Geräte' are found">
                <img id="DeviceTypes"
                    src="{{environment.storageUrl}}/models3d/general\helpPage\introduction/Notification/types_overview.png"
                    class="embed-responsive mx-auto d-block" style="width: 25%;" alt="Device Types">
            </div>
        </li>
    </ol>
</div>